<template>
  <table class="result_topic_tabel">
    <tr>
      <th align="center">現在参加中</th>
      <td align="right">{{participants}}人</td>
    </tr>
    <tr>
      <th align="center">
        わたしの合計ポイント
        <a @click="openPDF('about_point')">
          <v-icon color="info" class="info-btn">
            mdi-information-outline
          </v-icon>
        </a>
      </th>
      <td align="right">{{campaignUser.total_point}}pt</td>
    </tr>
    <tr>
      <th align="center">
        わたしの順位
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
              mdi-help-circle
            </v-icon>
          </template>
          <span>順位は1時間に1回更新されます。(9時から21時)</span>
        </v-tooltip>
      </th>
      <td align="right">{{myRank}}</td>
    </tr>
  </table>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'

// ユーザーランクの取得
const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      rank
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return data
}

export default {
  name: 'ResultContinueBonus',
  data () {
    return {
      participants: '',
      myRank: ''
    }
  },
  props: ['campaignUser'],
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async created () {
    this.getCampaignJson()
    // ユーザー取得（ランク）
    const userview = await getUserViewInfo(this.campaign.id)
    this.myRank = userview.rank ? userview.rank + '位' : '未計算'
  },
  methods: {
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得 ※ログイン画面との整合性を合わせるため
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const targetCampaign = campaignList.find(item => item.is_continuity === me.campaign.is_continuity)
            if (targetCampaign) {
              me.participants = targetCampaign.participants
            }
          }
        }
      }
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.result_topic_tabel {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
</style>
